export const getStyled = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
  },
  multFieldLine: {
    display: 'flex',
  },

  extraAttr1: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'nowrap',
  },

  extraAttr: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  buttonProgress: {
    color: theme.custom.colors.confirmButton,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 2000,
  },
  colorAdorment: {
    width: 20,
    height: 20,
  },
});
